<template>
    <modal :id="`preview-file-modal-${id}`">
        <template slot="body">
            <div class="preview-container ">
               <div class="preview" v-if="canPreview">
                   <iframe :src="file.full_path" style="width: 100%; min-height:300px" frameborder="0"></iframe>
               </div>
               <div v-else class="text-center">
                   Preview not Available<br>Click "Download"
               </div>
           </div>
        </template>
        <template slot="footer">
            <button class="btn btn-dafault" @click="closeModal(`preview-file-modal-${id}`)">
                Close
            </button>
            <button type="submit" class="btn btn-success" @click="redirectTo(file.full_path, '_blank')">Download</button>
        </template>
    </modal>
</template>
<script>
    export default {

        props: {
            file: {
                type: Object,
                required: true,
            },
            id: {
                type: Number,
                required: false,
                default: '',
            }
        },

        data() {
            return {
                previewTypes: [
                    'image/png',
                    'image/jpeg',
                    'image/gif',
                    'application/pdf'
                ]
            }
        },

        mounted(){
            $('iframe').on('load', function() {
                $('iframe').contents().find("img").css({
                    'width': '100%',
                    'height': 'auto'
                })
            });
        },

        computed:{
            canPreview() {
                return this.previewTypes.includes(this.file.type)
            }
        }
    }
</script>
